import { formatNumber } from "../../../utils";
import { COMPACT_QUERY } from "../../../utils/hooks/useCompact";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const compact = "@media " + COMPACT_QUERY;

interface DeductionFooterProps {
  totalAmount: number;
}

export default function DeductionFooter({ totalAmount }: DeductionFooterProps) {
  return (
    <Paper
      sx={{
        // Offset by the live sidebar width so this fixed bar stays aligned
        // with the main content area instead of sliding under the sidebar.
        left: "var(--gb-sidebar-width, 0px)",
        right: 0,
        height: "66px",
        position: "fixed",
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "24px",
        boxShadow: "0 -4px 24px -8px rgba(0,0,0,0.10)",
        [compact]: {
          height: "48px",
          padding: "12px 16px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Typography>ราคาหักรวม:</Typography>
        <Typography color="error" fontWeight={600}>
          {formatNumber(totalAmount)}
        </Typography>
        <Typography>บาท</Typography>
      </Box>
    </Paper>
  );
}
